<template>
  <div class="wrapper">
    <div class="offline-img-block">
      <div class="row-1">
        <div class="first-item"></div>
        <div class="second-item"></div>
      </div>
      <div class="row-2">
        <div class="third-item"></div>
        <div class="forth-item"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Offline'
}
</script>

<style scoped lang="stylus">
  .wrapper
    width: 100%
    background-color: #eeeeee
    background-image: url("../../../assets/images/advantage-second-gray-bg.png")
    background-position: center
    background-size: cover
    .offline-img-block
      width: 1140px
      height: 532px
      display: flex
      margin: 0 auto
      flex-direction: column
      padding: 51px 0 40px 0
      .row-1
        display: flex
        flex: 1
        justify-content: space-between
        height: 252px
        .first-item
          flex: 0 0 35.2%
          background-image: url("../../../assets/images/laladui.png")
          background-position: center
          background-size: contain
          background-repeat: no-repeat
        .second-item
          flex: 0 0 62.6%
          background-image: url("../../../assets/images/saidao.png")
          background-position: center
          background-size: contain
          background-repeat: no-repeat
      .row-2
        display: flex
        justify-content: space-between
        flex: 1
        height: 290px
        .third-item
          flex: 0 0 63.7%
          background-image: url("../../../assets/images/bolanhui.png")
          background-position: center
          background-size: cover
        .forth-item
          flex: 0 0 33.7%
          background-image: url("../../../assets/images/bugizhan.png")
          background-position: center
          background-size: cover
</style>



// WEBPACK FOOTER //
// src/pages/advantage/components/Offline.vue